import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton, FlexStack } from '~/components/atomic';
import { Input } from '~/components/atomic';

interface BottomSheetInnerProps {
  id: string;
  title: string;
  desc: string;
  placeholder: string;
  text: string;
  setText: (text: string) => void;
  onClick: () => void;
  maxText?: number;
}

export default function BottomSheetInner({
  id,
  title,
  desc,
  placeholder,
  text,
  setText,
  onClick,
  maxText = 20,
}: BottomSheetInnerProps) {
  return (
    <Container>
      <FlexStack>
        <TitleBox>
          <strong>{title}</strong>
        </TitleBox>
        <DescBox>
          <p>{desc}</p>
        </DescBox>
      </FlexStack>
      <FormWrapper>
        <Input
          id={id}
          placeholder={placeholder}
          text={text}
          setText={setText}
          textLengthOpt
          maxText={maxText}
          inputWrapperName='sheet-inner'
        />
        <div>
          <DefaultButton disabled={text.trim().length === 0} onClick={onClick}>
            Save
          </DefaultButton>
        </div>
      </FormWrapper>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .sheet-inner {
    background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
  }
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    display: block;

    strong {
      display: block;
      ${theme.fontStyle.text.body18_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: block;

    p {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.content_light_3};
      word-break: keep-all;
    }
  `}
`;
